export type RuntimeConfig = {
  appInsightsConnectionString?: string;
};

type RuntimeWindow = Window & {
  __RUNTIME_CONFIG__?: RuntimeConfig;
};

export function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') return {};
  return (window as RuntimeWindow).__RUNTIME_CONFIG__ || {};
}
